import { redirect } from "app/routes/Routes";
import { deleteProcessEmployeesBulkSession } from "../../infrastructure/repository/employees-repository";
import { translate } from "../../infrastructure/translate/localization";
import { findCompanyId } from "../../infrastructure/repository/company-repository";
import { displayEmployeesPage } from "./displays/display-employees-page";
import { showErrorMessage } from "../commons/show-error-message";
import { logError, addContextLog } from "../../infrastructure/log";

export async function cancelProcessEmployeesBulkSession() {
  try {
    const companyId = await findCompanyId();
    await deleteProcessEmployeesBulkSession(companyId);
    addContextLog(
      "info",
      "deleteProcessEmployeesBulkSession",
      "display-screen",
      { companyId }
    );
    redirect("/v2/employees");
    displayEmployeesPage();
  } catch (e) {
    logError(e, `Error to deleteProcessEmployeesBulkSession`);
    showErrorMessage(translate("common-messages.basic-error-message"), true);
  }
}
